import React, { FC } from 'react';
import classnames from 'classnames';
// @ts-ignore
import * as rbd from 'react-beautiful-dnd';
import CardCommon from '@sg/components/CardCommon';
import Loading from '@intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import FinanceOverviewCard from './OverviewCard';
import FinanceProjectRow from './ProjectRow';
import type { IGggFinanceProjectRow, IGggFinanceSummary } from '../../types';

interface IProps {
  summary?: IGggFinanceSummary | null;
  studioCover?: string;
  studioName?: string;
  projects: IGggFinanceProjectRow[];
  overviewLoading?: boolean;
  isEditing?: boolean;
  handleProjectsReorder?: (projects: IGggFinanceProjectRow[]) => void;
}

const LiveFinanceOverview: FC<IProps> = (props) => {
  const {
    summary,
    studioCover,
    studioName,
    projects,
    overviewLoading = false,
    isEditing = false,
    handleProjectsReorder,
  } = props;

  const handleProjectDragEnd = (result: any) => {
    if (!result?.destination) {
      return;
    }
    const sourceIndex = result?.source?.index;
    const destIndex = result?.destination?.index;
    if (sourceIndex === destIndex) {
      return;
    }
    const reordered = Array.from(projects || []);
    const [moved] = reordered.splice(sourceIndex, 1);
    reordered.splice(destIndex, 0, moved);
    handleProjectsReorder?.(reordered);
  };

  return (
    <>
      <div className="dbs-ltf__overview dbs-home-studio-card">
        <FinanceOverviewCard
          summary={summary}
          studioCover={studioCover}
          studioName={studioName}
          loading={overviewLoading}
        />
        <CardCommon className="dbs-ltf-overview-placeholder">
          <div className="dbs-ltf-overview-placeholder__text">
            Financial data for other studios will be available in future.
          </div>
        </CardCommon>
      </div>
      <CardCommon
        className={classnames(
          'dbs-ltf__project-list card-common-Inertia Inactive',
          'dbs-ltf__arrow-connector--left',
          {
            'dbs-ltf__project-list--editing': isEditing,
          },
        )}
      >
        {overviewLoading ? (
          <Loading style={{ minHeight: '300px' }} />
        ) : (projects?.length ?? 0) === 0 ? (
          <NoData style={{ height: '300px' }} text="No Data" />
        ) : (
          <rbd.DragDropContext onDragEnd={handleProjectDragEnd}>
            <rbd.Droppable droppableId="live-finance-projects">
              {(droppableProvided: any) => (
                <div
                  className="dbs-ltf-project-rows"
                  ref={droppableProvided.innerRef}
                  {...droppableProvided.droppableProps}
                >
                  {projects.map((project, index) => {
                    const draggableId = String(
                      project?.game_title ?? `project-${index}`,
                    );
                    return (
                      <rbd.Draggable
                        key={draggableId}
                        draggableId={draggableId}
                        index={index}
                        isDragDisabled={!isEditing}
                      >
                        {(draggableProvided: any, snapshot: any) => (
                          <div
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            className={classnames('dbs-ltf-project-row-draggable', {
                              'is-dragging': snapshot?.isDragging,
                            })}
                          >
                            <FinanceProjectRow
                              project={project}
                              isEditing={isEditing}
                              dragHandleProps={draggableProvided.dragHandleProps}
                            />
                          </div>
                        )}
                      </rbd.Draggable>
                    );
                  })}
                  {droppableProvided.placeholder}
                </div>
              )}
            </rbd.Droppable>
          </rbd.DragDropContext>
        )}
      </CardCommon>
    </>
  );
};

export default LiveFinanceOverview;
